import { StatusService } from '@flippingbook/web.utils/dist/Status';
import type { IStatusService } from '@flippingbook/web.utils/dist/Status';

import { statusApi } from '@/services/instance/api/statusApi';

export const statusService: IStatusService = new StatusService({
    statusApi,
});
